export default __webpack_public_path__ + "static/media/vn.1dd81500.svg";